import { BUCKET_COUNT } from '@spotify/confidence-core-react';

export const formatWeight = (
  rawWeight: unknown,
  { decimals = 2 }: { decimals?: number } = {},
): string => {
  const weight = Number(rawWeight);
  if (Number.isNaN(weight)) return String(rawWeight);
  const percentage = (weight / BUCKET_COUNT) * 100;
  return `${Number(percentage.toFixed(decimals))}%`;
};
